import { Pipe, PipeTransform } from '@angular/core'
import { isPublicProfileEnabled } from './utils/corp-member.util'

@Pipe({
  name: 'hasPublicProfile',
})
export class HasPublicProfilePipe implements PipeTransform {
  transform(entity: { public_profile?: boolean | string } | null | undefined): boolean {
    return isPublicProfileEnabled(entity)
  }
}
